import { Component, DestroyRef, EventEmitter, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { ObservedAuctionDTO } from "@shared/model/auction.model";
import { ApiService } from "@shared/services/api.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { fromEvent } from "rxjs";

@Component({
	selector: "app-live-full",
	templateUrl: "./live-full.component.html",
	styleUrl: "./live-full.component.scss",
	standalone: false
})
export class LiveFullComponent implements OnInit, OnDestroy {
	private mqttService = inject(MqttService);
	private dialog = inject(MatDialog);
	private apiService = inject(ApiService);

	/** Potential MQTT connection error dialog content */
	@ViewChild('connectError') connectError!: TemplateRef<any>;
	/** Keeps track of whether we showed the connection error dialog */
	private warningShown = false;
	private destroyRef = inject(DestroyRef);

	protected closeTemplateModal = () => { };
	/** Delta time in milliseconds between local machine time and server-provided time */
	protected timeOffset = 0;
	protected notAllBlind = true;
	leasysObservedAuctions: ObservedAuctionDTO[];
	observedAuctions: ObservedAuctionDTO[];
	// flagAnimation = false;
	destroyed = false;
	reconnectEmitter = new EventEmitter<void>();

	constructor() {
		this.apiService.getTimeUsingGET()
			.subscribe(value => { this.timeOffset = value - Date.now(); });
	}

	protected trimAuction = (auctions: ObservedAuctionDTO[], auction: ObservedAuctionDTO) => {
		const index = auctions.indexOf(auction);
		if (index !== -1) {
			auctions.splice(index, 1);
		}
	};

	ngOnInit() {
		this.mqttService.connect(true).subscribe(() => {
			this.apiService
				.getObservedAuctionsLotsUsingGET()
				.subscribe(value => {
					value.sort((a, b) =>
						a.auctionDTO.endDate < b.auctionDTO.endDate
							? -1
							: a.auctionDTO.endDate > b.auctionDTO.endDate
								? 1
								: 0
					);
					this.observedAuctions = [];
					this.leasysObservedAuctions = [];
					for (const a of value) {
						this[a.auctionDTO.auctionType === "LEA" ? "leasysObservedAuctions" : "observedAuctions"].push(a);
					}
					this.notAllBlind = this.leasysObservedAuctions.concat(this.observedAuctions).some(a => a.auctionDTO.type === "OPEN");
					this.mqttService.disconnected()
						.pipe(takeUntilDestroyed(this.destroyRef))
						.subscribe(() => {
							console.log("MQTT disconnected");
							if (!this.destroyed) {
								if (!this.warningShown) {
									this.warningShown = true;
									const dialogRef = this.dialog.open(this.connectError, { maxWidth: 400 })
									this.closeTemplateModal = () => {
										dialogRef.close();
										this.closeTemplateModal = () => { };
									};
								}
								console.log("MQTT reconnect");
								this.mqttService.connect().subscribe(() => {
									this.reconnectEmitter.emit();
								});
							}
						});
					fromEvent<BeforeUnloadEvent>(window, 'beforeunload')
						.pipe(takeUntilDestroyed(this.destroyRef))
						.subscribe(() => { this.ngOnDestroy(); });
				});
		});
	}
	ngOnDestroy(): void {
		if (!this.destroyed) {
			this.destroyed = true;
			this.mqttService.disconnect();
		}
	}
}